import { useEffect, useState } from 'react';

export const useProgressiveImage = ({ src, loading }) => {
  const [sourceLoaded, setSourceLoaded] = useState(null);

  useEffect(() => {
    loading && loading(true);
    const img = new Image();
    img.src = src;
    img.onload = () => {
      setSourceLoaded(src);
      loading && loading(false);
    };
  }, [src]);

  return sourceLoaded;
};
